// @ts-check
import React from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import { IntroTarget, introTargets } from 'components/introjs';
import useLeftHandLayout from 'components/LeftHandLayout/context';
import CartButton from '../../common/CartButton';
import MobileMenuButton from '../../common/MobileMenuButton';
import TopNavSearch from '../../common/SearchButton';
import TopNavSupport from '../../common/SupportMenu';
import TopNavUser from '../../common/UserMenu';
import LeftNav from '../../LeftNav/LeftNav';
import TopNavCreate from '../Create';
import TopNavTitle from '../Title';

const Standard = () => {
	const { screenSize } = useLeftHandLayout();
	const isLarge = screenSize === 'large';

	return (
		<>
			<LeftNav />
			{!isLarge && (
				<IntroTarget introId={introTargets.navMediumButton}>
					<MobileMenuButton showAlerts />
				</IntroTarget>
			)}
			<TopNavTitle sx={{ flex: '0% 1 1', overflow: 'auto' }} />
			<Stack
				direction="row"
				useFlexGap
				sx={{
					alignItems: 'center',
					gap: 150,
				}}
			>
				<TopNavCreate />
				<CartButton />
				<TopNavSearch />
				<TopNavSupport />
				<TopNavUser />
			</Stack>
		</>
	);
};

export default Standard;
